import { render, staticRenderFns } from "./immersion02.vue?vue&type=template&id=35e36a8b&scoped=true&"
import script from "./immersion02.vue?vue&type=script&lang=js&"
export * from "./immersion02.vue?vue&type=script&lang=js&"
import style0 from "./immersion02.vue?vue&type=style&index=0&id=35e36a8b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e36a8b",
  null
  
)

export default component.exports